import { defineAction } from '~/prix'
import familyListAction from './familyList.action.json' with { type: 'json' }
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'

const familyExpressionForCharacteristics = z.object({
  originalId: z.string().describe('ID original'),
  dataSourceId: z.number().describe('ID da fonte de dados').nullish(),
  residenceCode: z.string().describe('ID original do domicílio').nullish(),
  responsibleFamilyMemberCpf: z.string().describe('CPF do responsável familiar').nullish(),
  responsibleFamilyMemberCns: z.string().describe('CNS do responsável familiar').nullish(),
  moved: z.boolean().describe('Família mudou-se').nullish(),
  createdAt: z.string().describe('Data de criação').nullish(),
  updatedAt: z.string().describe('Data de atualização').nullish(),
  isDeleted: z.boolean().describe('Registro excluído').nullish(),
})

export const familyExpression = expression(familyExpressionForCharacteristics.shape)

const familyListDefinition = defineAction({
  ...familyListAction,

  input: z.object({
    filter: familyExpression.optional(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().min(0).nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      originalId: 'Identificador',
    }).nullish(),
    order: enumerated({
      ascending: 'Ordem crescente',
      descending: 'Ordem crescente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(familyExpressionForCharacteristics),
    count: z.number().optional(),
  }),
})

export default familyListDefinition
